import Vue from 'vue'
import axios from 'axios'

const initState = {
  plans: null,
  prices: null,
  priceCourseRelations: null,
}

export default {
  namespaced: true,
  state: Vue.util.extend({}, initState),
  mutations: {
    getAllSuccess(state, plans) {
      state.plans = plans.sort((a, b) => { return a.amount - b.amount })
    },
    getAllPricesSuccess(state, prices) {
      state.prices = prices.sort((a, b) => { return a.amount - b.amount })
    },
    getAllPriceCourseRelationsSuccess(state, priceCourseRelations) {
      state.priceCourseRelations = priceCourseRelations.sort((a, b) => { return b.updated_at - a.updated_at })
    },
    subscribeSuccess(state, plan) {
      if (this.state.auth.user && this.state.auth.user.agency) {
        let agency = this.state.auth.user.agency
        agency = {
          ...agency,
          stripe_price: plan,
          subscribed: true,
          default_subscribed: true
        }
        this.state.auth.user = {
          ...this.state.auth.user,
          agency
        }
      }
    },
    subscribeAppSuccess(state, { plan, premiumApps, premiumElements }) {
      if (this.state.auth.user && this.state.auth.user.agency) {
        let agency = this.state.auth.user.agency
        const appPlans = {
          ...agency.app_plans,
          [plan]: true
        }
        const newPremiumApps = [
          ...agency.premiumApps,
          ...premiumApps
        ]
        const newPremiumElements = [
          ...agency.premiumElements,
          ...premiumElements
        ]
        agency = {
          ...agency,
          app_plans: appPlans,
          premiumApps: newPremiumApps,
          premiumElements: newPremiumElements
        }
        this.state.auth.user = {
          ...this.state.auth.user,
          agency
        }
      }
    },
    subscribeResellerSuccess(state, plan) {
      if (this.state.auth.user && this.state.auth.user.agency) {
        let premiumApps = []
        let premiumElements = []

        // Unlimited Plan
        if (this.state.app.config && this.state.app.config.unlimitedPlans && this.state.app.config.unlimitedPlans.includes(plan)) {
          if (this.state.app.config.premiumAppDirectory) {
            premiumApps = JSON.parse(JSON.stringify(Object.keys(this.state.app.config.premiumAppDirectory)))
          }
          if (this.state.app.config.allPremiumElements) {
            premiumElements = JSON.parse(JSON.stringify(this.state.app.config.allPremiumElements))
          }
        }

        let agency = this.state.auth.user.agency
        agency = {
          ...agency,
          reseller_plan: plan,
          subscribed: true,
          reseller_subscribed: true,
          premiumApps,
          premiumElements
        }
        this.state.auth.user = {
          ...this.state.auth.user,
          agency
        }
      }
    },
    createPriceSuccess(state, price) {
      if (state.prices) state.prices.push(price)
    },
    updatePriceSuccess(state, price) {
      if (state.prices) state.prices = state.prices.map((p) => (p.id === price.id ? price : p))
    },
    createPlanSuccess(state, plan) {
      if (state.plans) state.plans.push(plan)
    },
    updatePlanSuccess(state, plan) {
      if (state.plans) state.plans = state.plans.map((p) => (p.id === plan.id ? plan : p))
    },
    resumeSuccess(state, user) { this.state.auth.user = user },
    resetAllSuccess(state) {
      for (let f in state) {
        Vue.set(state, f, initState[f])
      }
    }
  },
  actions: {
    resetAll({ commit }) { commit('resetAllSuccess') },
    getAllOrderPages({ commit }, { queries }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`subscriptions/order-pages`, { params: queries })
          .then((res) => resolve(res.data))
          .catch((err) => reject(err))
      })
    },
    getOrderPage({ commit }, { orderPageId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`subscriptions/order-pages/${orderPageId}`)
          .then((res) => resolve(res.data.orderPage))
          .catch((err) => reject(err))
      })
    },
    getAllPrices({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`subscriptions/prices`)
          .then((res) => {
            commit('getAllPricesSuccess', res.data.data)
            resolve(true)
          })
          .catch((err) => reject(err))
      })
    },
    getAllPlans({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`subscriptions/plans`)
          .then((res) => {
            commit('getAllSuccess', res.data.data)
            resolve(true)
          })
          .catch((err) => reject(err))
      })
    },
    getAllPriceCourseRelations({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`subscriptions/price_course_relations`)
          .then((res) => {
            commit('getAllPriceCourseRelationsSuccess', res.data.data)
            resolve(true)
          })
          .catch((err) => reject(err))
      })
    },
    findPlan({ commit }, planId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`plans/${planId}`)
          .then((res) => resolve(res.data.data))
          .catch((err) => reject(err))
      })
    },
    findPrice({ commit }, priceId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`prices/${priceId}`)
          .then((res) => resolve(res.data.data))
          .catch((err) => reject(err))
      })
    },
    publishOrderPage({ commit }, { orderPageId }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/subscriptions/order-pages/${orderPageId}/publish`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    createOrderPage({ commit }, orderPage) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/subscriptions/order-pages`, orderPage)
          .then((res) => resolve(res.data.orderPage))
          .catch((error) => reject(error))
      })
    },
    updateOrderPage({ commit }, orderPage) {
      return new Promise((resolve, reject) => {
        axios
          .put(`subscriptions/order-pages/${orderPage.id}`, orderPage)
          .then((res) => resolve(res.data.orderPage))
          .catch((error) => reject(error))
      })
    },
    cloneOrderPage({ commit }, { orderPageId }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/subscriptions/order-pages/${orderPageId}/clone`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    deleteOrderPage({ commit }, { orderPageId }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/subscriptions/order-pages/${orderPageId}`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    createPrice({ commit }, price) {
      return new Promise((resolve, reject) => {
        axios
          .post(`prices`, price)
          .then((res) => {
            commit('createPriceSuccess', res.data.data)
            resolve(true)
          })
          .catch((err) => reject(err))
      })
    },
    createPlan({ commit }, plan) {
      return new Promise((resolve, reject) => {
        axios
          .post(`plans`, plan)
          .then((res) => {
            commit('createPlanSuccess', res.data.data)
            resolve(true)
          })
          .catch((err) => reject(err))
      })
    },
    updatePrice({ commit }, price) {
      return new Promise((resolve, reject) => {
        axios
          .put(`prices/${price.id}`, price)
          .then((res) => {
            commit('updatePriceSuccess', res.data.data)
            resolve(true)
          })
          .catch((err) => reject(err))
      })
    },
    updatePlan({ commit }, plan) {
      return new Promise((resolve, reject) => {
        axios
          .put(`plans/${plan.id}`, plan)
          .then((res) => {
            commit('updatePlanSuccess', res.data.data)
            resolve(true)
          })
          .catch((err) => reject(err))
      })
    },
    getPlanByName({ commit }, name) {
      return new Promise((resolve, reject) => {
        axios
          .get(`subscriptions/plans/${name}`)
          .then((res) => resolve(res.data))
          .catch((err) => reject(err))
      })
    },
    subscribe({ commit }, plan) {
      return new Promise((resolve, reject) => {
        axios
          .post(`subscriptions/${plan}`)
          .then(() => {
            commit('subscribeSuccess', plan)
            resolve(true)
          })
          .catch((err) => reject(err))
      })
    },
    subscribeApp({ commit }, { plan, premiumApps, premiumElements, coupon }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`subscriptions/${plan}?section=app-${plan}&coupon=${coupon}`)
          .then(() => {
            commit('subscribeAppSuccess', { plan, premiumApps, premiumElements })
            resolve(true)
          })
          .catch((err) => reject(err))
      })
    },
    subscribeReseller({ commit }, { plan, coupon }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`subscriptions/${plan}?section=reseller&coupon=${coupon}`)
          .then(() => {
            commit('subscribeResellerSuccess', plan)
            resolve(true)
          })
          .catch((err) => reject(err))
      })
    },
    subscribeResellerPromo({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`subscriptions/promo`)
          .then((res) => {
            commit('subscribeResellerSuccess', res.data.planId)
            resolve(true)
          })
          .catch((err) => reject(err))
      })
    },
    subscribeUnlimited({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`subscriptions/subscribe-unlimited`)
          .then(() => resolve(true))
          .catch((err) => reject(err))
      })
    },
    cancel({ commit }, { userId, planType }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`subscriptions/${userId}/${planType}/cancel`)
          .then(() => resolve(true))
          .catch((err) => reject(err))
      })
    },
    resume({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`subscriptions/resume`)
          .then((res) => {
            commit('resumeSuccess', res.data.user)
            resolve(true)
          })
          .catch((err) => reject(err))
      })
    },
    checkCoupon({ commit }, coupon) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/subscriptions/check-coupon?code=${coupon}`)
          .then((res) => resolve(res.data.coupon))
          .catch((err) => reject(err))
      })
    }
  },
  getters: {
    allPrices(state) { return state.prices },
    allPlans(state) { return state.plans },
    allPriceCourseRelations(state) { return state.priceCourseRelations },
  }
}